module.exports = __webpack_public_path__ + "img/success.ed625be0.svg";